import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ScreensQuestionResource } from '@Components/mras/core';
import { SharedModule } from '@Shared/shared.module';

@Component({
    selector: 'jhi-select-input',
    templateUrl: './select-input.component.html',
    imports: [SharedModule]
})
export class SelectInputComponent implements OnInit, OnChanges {
    @Input() question: ScreensQuestionResource;
    @Input()
        value: string;
    @Output()
        valueChange = new EventEmitter<string>();

    @Input()
        summaryMode: boolean;

    @Input()
        name: string;
    @Input()
        options: any[];
    @Input()
        disabled: boolean;
    @Input()
        valueMapper: any;
    @Input()
        labelMapper: any;
    @Output()
        action = new EventEmitter<void>();
    @Input()
        enableChangeButton: boolean;

    selectValue: string;
    placeHolder: string;

    ngOnInit(): void {
        this.selectValue = this.value;

        if (this.placeHolder === "Countries") {
            this.placeHolder = "Country";
        }        
    }

    ngOnChanges(): void {
        this.selectValue = this.value;
    }

    toValue(option: any) {
        if (this.valueMapper == null) {
            return option;
        }
        return this.valueMapper(option);
    }

    toLabel(option: any) {
        if (this.labelMapper == null) {
            return option;
        }
        return this.labelMapper(option);
    }

    onClick() {
        this.value = this.selectValue;
        
        if (this.question?.invalid) {
            this.question.invalid = false;
        }

        this.valueChange.emit(this.value);
        this.action.emit(null);
    }

    filter(options: any[]) {
        return options
            .map(e => {
                const value = this.toValue(e);
                if (value === 'UNKNOWN') {
                    return null;
                } else {
                    return e;
                }
            })
            .filter(e => e != null);
    }
}
